/* =====================================================================
   CINTOFLEX™ — LANDING PAGE BEHAVIOR
   Vanilla JS, sin dependencias externas. Namespaced en window.CintoFlex
   para no chocar con el JS del theme.
   ===================================================================== */
(function () {
  'use strict';

  var state = {
    packageIndex: null,
    variantId: null,
    unitColors: {},
    protectionSelected: false,
    isAdding: false
  };

  function qsAll(selector, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(selector));
  }

  function updateVariantId() {
    if (state.packageIndex == null) return;
    var pkgBtn = qsAll('[data-cf-package][data-package-index="' + state.packageIndex + '"]')[0];
    if (!pkgBtn) return;
    var maps = qsAll('[data-cf-variant-map]', pkgBtn);
    var match = maps[0] || null;
    maps.forEach(function (m) {
      if (m.getAttribute('data-color') === 'Negro') match = m;
    });
    state.variantId = match ? match.getAttribute('data-variant-id') : null;
  }

  function defaultUnitColors(qty) {
    var arr = [];
    for (var i = 0; i < qty; i++) arr.push('Negro');
    return arr;
  }

  function syncColorUnitButtons(pkgIdx) {
    var colors = state.unitColors[pkgIdx] || [];
    qsAll('[data-cf-unit-color][data-package-index="' + pkgIdx + '"]').forEach(function (btn) {
      var unit = parseInt(btn.getAttribute('data-unit'), 10);
      var match = colors[unit - 1] === btn.getAttribute('data-color');
      btn.classList.toggle('is-selected', match);
      btn.setAttribute('aria-checked', match ? 'true' : 'false');
    });
  }

  function updatePrimaryColorImage() {
    if (state.packageIndex == null) return;
    var colors = state.unitColors[state.packageIndex] || [];
    var primary = colors[0] || 'Negro';
    qsAll('[data-color-image]').forEach(function (el) {
      el.hidden = el.getAttribute('data-color-image') !== primary;
    });
  }

  function selectPackage(idx, sourceBtn) {
    state.packageIndex = idx;
    if (!state.unitColors[idx]) {
      var qtyAttr = qsAll('[data-cf-colorunits][data-package-index="' + idx + '"]')[0];
      var rows = qtyAttr ? qsAll('.cf-colorunit', qtyAttr).length : 1;
      state.unitColors[idx] = defaultUnitColors(rows || 1);
    }

    qsAll('[data-cf-package]').forEach(function (btn) {
      var match = btn.getAttribute('data-package-index') === String(idx);
      btn.classList.toggle('is-selected', match);
      btn.setAttribute('aria-checked', match ? 'true' : 'false');
    });

    qsAll('[data-cf-colorunits]').forEach(function (block) {
      block.hidden = block.getAttribute('data-package-index') !== String(idx);
    });
    syncColorUnitButtons(idx);
    updatePrimaryColorImage();

    var reference = sourceBtn || qsAll('[data-cf-package][data-package-index="' + idx + '"]')[0];
    if (reference) {
      var data = reference.dataset;
      qsAll('[data-cf-mirror-price]').forEach(function (el) {
        el.textContent = data.priceFormatted || '';
      });
      qsAll('[data-cf-mirror-compare]').forEach(function (el) {
        el.textContent = data.compareFormatted || '';
        el.hidden = !data.compareFormatted;
      });
      qsAll('[data-cf-mirror-savings]').forEach(function (el) {
        el.textContent = data.savingsFormatted ? ('Ahorras ' + data.savingsFormatted) : '';
        el.hidden = !data.savingsFormatted;
      });
    }

    updateVariantId();
  }

  function selectUnitColor(pkgIdx, unit, colorName) {
    if (!state.unitColors[pkgIdx]) return;
    state.unitColors[pkgIdx][unit - 1] = colorName;
    syncColorUnitButtons(pkgIdx);
    if (pkgIdx === state.packageIndex && unit === 1) {
      updatePrimaryColorImage();
    }
  }

  function initPackageDefault() {
    var selectedPkg = qsAll('[data-cf-package].is-selected')[0] || qsAll('[data-cf-package]')[0];
    if (selectedPkg) {
      selectPackage(selectedPkg.getAttribute('data-package-index'), selectedPkg);
    }
  }

  function buildColorNote(pkgIdx) {
    var colors = state.unitColors[pkgIdx] || [];
    if (colors.length <= 1) return colors[0] || '';
    return colors.map(function (c, i) { return 'Cinturón ' + (i + 1) + ': ' + c; }).join(' · ');
  }

  function toggleProtection(checked) {
    state.protectionSelected = checked;
    qsAll('[data-cf-protection-toggle]').forEach(function (input) {
      input.checked = checked;
    });
  }

  function getProtectionVariantId() {
    var input = qsAll('[data-cf-protection-toggle]')[0];
    return input ? input.getAttribute('data-variant-id') : null;
  }

  function setButtonLoading(btn, isLoading) {
    btn.classList.toggle('is-loading', isLoading);
    btn.disabled = isLoading;
  }

  function showError(btn, message) {
    var scope = btn.closest('[data-cf-buybox], .cf-sticky') || document;
    var errorEl = scope.querySelector('[data-cf-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.classList.add('is-visible');
  }

  function clearErrors() {
    qsAll('[data-cf-error]').forEach(function (el) {
      el.classList.remove('is-visible');
      el.textContent = '';
    });
  }

  function addToCart(btn) {
    if (state.isAdding) return;
    if (!state.variantId) {
      showError(btn, 'Selecciona un paquete antes de continuar.');
      return;
    }

    state.isAdding = true;
    clearErrors();
    qsAll('[data-cf-add-to-cart]').forEach(function (b) { setButtonLoading(b, true); });

    var mainItem = { id: state.variantId, quantity: 1 };
    var colorNote = buildColorNote(state.packageIndex);
    if (colorNote) {
      mainItem.properties = { Colores: colorNote };
    }

    var items = [mainItem];
    if (state.protectionSelected) {
      var protectionId = getProtectionVariantId();
      if (protectionId) items.push({ id: protectionId, quantity: 1 });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error((err && err.description) || 'No se pudo agregar el producto al carrito.');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        state.isAdding = false;
        qsAll('[data-cf-add-to-cart]').forEach(function (b) { setButtonLoading(b, false); });
        showError(btn, err.message || 'Ocurrió un error. Intenta de nuevo.');
      });
  }

  function initGallery() {
    qsAll('.cf-gallery').forEach(function (gallery) {
      var thumbs = qsAll('[data-cf-thumb]', gallery);
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var targetSelector = thumb.getAttribute('data-target');
          var target = gallery.querySelector(targetSelector);
          if (!target) return;

          qsAll('[data-cf-mainitem]', gallery).forEach(function (panel) {
            panel.hidden = true;
          });
          target.hidden = false;

          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function toggleFaqItem(item, forceClose) {
    var trigger = item.querySelector('.cf-faq-item__trigger');
    var panel = item.querySelector('.cf-faq-item__panel');
    var isOpen = item.getAttribute('data-open') === 'true';
    var open = forceClose ? false : !isOpen;

    item.setAttribute('data-open', open ? 'true' : 'false');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
  }

  function initFaq() {
    qsAll('.cf-faq').forEach(function (faq) {
      var items = qsAll('.cf-faq-item', faq);
      items.forEach(function (item) {
        var trigger = item.querySelector('.cf-faq-item__trigger');
        trigger.addEventListener('click', function () {
          var willOpen = item.getAttribute('data-open') !== 'true';
          items.forEach(function (other) {
            if (other !== item) toggleFaqItem(other, true);
          });
          toggleFaqItem(item, !willOpen);
        });
      });
    });
  }

  function initStickyBar() {
    var sticky = document.querySelector('[data-cf-sticky]');
    var anchor = document.querySelector('[data-cf-hero-buybox]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);
  }

  function initEvents() {
    document.addEventListener('click', function (e) {
      var pkgBtn = e.target.closest('[data-cf-package]');
      if (pkgBtn) {
        selectPackage(pkgBtn.getAttribute('data-package-index'), pkgBtn);
        return;
      }

      var unitColorBtn = e.target.closest('[data-cf-unit-color]');
      if (unitColorBtn) {
        selectUnitColor(
          unitColorBtn.getAttribute('data-package-index'),
          parseInt(unitColorBtn.getAttribute('data-unit'), 10),
          unitColorBtn.getAttribute('data-color')
        );
        return;
      }

      var addBtn = e.target.closest('[data-cf-add-to-cart]');
      if (addBtn) {
        addToCart(addBtn);
        return;
      }
    });

    document.addEventListener('change', function (e) {
      var toggle = e.target.closest('[data-cf-protection-toggle]');
      if (toggle) {
        toggleProtection(toggle.checked);
      }
    });
  }

  function init() {
    initPackageDefault();
    initGallery();
    initFaq();
    initStickyBar();
    initEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CintoFlex = { selectPackage: selectPackage, selectUnitColor: selectUnitColor };
})();
